import { FC, useCallback, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { resourceExplorerViewBudgetsSelector } from "@/store/resource-explorer/selectors/budget/resourceExplorerViewBudgetsSelector";
import { DropdownSelect } from "@/components/common/select/dropdown-select/DropdownSelect";
import { HierarchySelectDropdownHeader } from "@/components/pages/common/hierarchy-select-visibility/components/HierarchySelectDropdownHeader";
import { ResourceExplorerBudgetOption } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/resource-explorer-metadata/components/budgets/budget-select/ResourceExplorerBudgetOption";
import { ResourceExplorerBudgetSelectFooter } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/resource-explorer-metadata/components/budgets/budget-select/ResourceExplorerBudgetSelectFooter";
import { ResourceExplorerBudgetSelectTriggerComponent } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/resource-explorer-metadata/components/budgets/budget-select/ResourceExplorerBudgetSelectTriggerComponent";
import { updateBillingExplorerChartSettingsThunk } from "@/store/resource-explorer/thunks/resource-explorer/updateBillingExplorerChartSettingsThunk";

interface ResourceExplorerBudgetSelectProps {
  selectedBudgetId: string;
}

export const ResourceExplorerBudgetSelect: FC<
  ResourceExplorerBudgetSelectProps
> = ({ selectedBudgetId }) => {
  const dispatch = useAppDispatch();

  const budgets = useAppSelector(resourceExplorerViewBudgetsSelector);

  const options = useMemo(() => {
    if (!budgets) {
      return [];
    }
    return budgets?.map((budget) => {
      return {
        value: budget.id,
        label: <ResourceExplorerBudgetOption budget={budget} />,
      };
    });
  }, [budgets]);

  const submitHandlerOnClose = useCallback(
    (selectedValues: string[]) => {
      const value = selectedValues[0];
      dispatch(
        updateBillingExplorerChartSettingsThunk({
          selected_budget_id: value,
        }),
      );
    },
    [dispatch],
  );

  return (
    <DropdownSelect
      singleSelect
      showSearch={options?.length > 5}
      label="Budgets"
      sortSelectedOptions={false}
      options={options}
      values={[selectedBudgetId ?? ""]}
      submitHandlerOnClose={submitHandlerOnClose}
      TriggerComponent={ResourceExplorerBudgetSelectTriggerComponent}
      DropdownHeader={HierarchySelectDropdownHeader}
      DropdownFooter={ResourceExplorerBudgetSelectFooter}
      listMaxHeight={600}
      listWidth={400}
    />
  );
};
